__turbopack_context__.v({
  "button": "theme-button-module__txChKa__button",
  "square": "theme-button-module__txChKa__square",
});
